export default __webpack_public_path__ + "99e75c152921138fac87b95db715197f.png";